// Angular imports
import { Component, Input, OnInit } from '@angular/core';

// Service imports
import { ServerErrorService } from '../../../../_services/shared-services/server-error.service';
import { HelperService } from '../../../../_services/shared-services/helper.service';
import { CiraHelpService } from '../../../../_services/shared-services/cira-help.service';
import { SharedWidgetsService } from '../../../_services/shared-widgets.service';

// Model imports
import { PropertyCommunityInfoResultDto } from '../../../../_models/property-community-info-result-dto';
import { UserDashboardProxyListResultDto } from '../../../_models/user-dashboard-proxy-list-result-dto';
import { UserDashboardItemResultDto } from '../../../_models/user-dashboard-item-result-dto';
import { UserDashboardByCommunityResultDto } from '../../../_models/user-dashboard-by-community-result-dto';
import { UserDashboardByCommunityParametersDto } from '../../../_models/user-dashboard-by-community-parameters-dto';

@Component({
    selector: 'app-user-dashboard-community-details',
    templateUrl: './user-dashboard-community-details.component.html',
    styleUrls: ['./user-dashboard-community-details.component.scss']
})
export class UserDashboardCommunityDetailsComponent implements OnInit {
    @Input() selectedUser: UserDashboardProxyListResultDto;
    @Input() selectedViewOption: any;
    @Input() selectedContext: PropertyCommunityInfoResultDto;
    @Input() workAreaItem: UserDashboardItemResultDto;

    loadingVisible: boolean;
    dashboardDetails: UserDashboardByCommunityResultDto[];

    constructor(
        private readonly errorService: ServerErrorService,
        private readonly helperService: HelperService,
        private readonly ciraHelp: CiraHelpService,
        private readonly widgetService: SharedWidgetsService
    ) {}

    ngOnInit(): void {
        if (!!this.workAreaItem) {
            this.loadingVisible = true;
            const params = new UserDashboardByCommunityParametersDto();
            params.workArea = this.workAreaItem.workArea;
            params.userId = this.selectedUser.userId;
            params.includeAll = this.selectedViewOption.value;
            this.widgetService.getUserDashboardByCommunity(params).subscribe(
                (results) => {
                    this.dashboardDetails = results;
                    this.loadingVisible = false;
                },
                (error) => {
                    this.errorService.displayError(error);
                    this.loadingVisible = false;
                }
            );
        }
    }

    onCommunityClick(rec: UserDashboardByCommunityResultDto): void {
        if (rec.communityId > 0) {
            this.helperService.openDefaultCommunityPageInNewWindow(rec.communityId);
        }
    }

    onHelpIconClick(rec: UserDashboardByCommunityResultDto): void {
        let communityId = !!this.selectedContext ? this.selectedContext.communityId : null;
        communityId = rec.communityId > 0 ? rec.communityId : communityId;
        const helpUrl = this.ciraHelp.getHelpLink(null, rec.helpKey, communityId);
        this.ciraHelp.showHelp(helpUrl);
    }
}
